import React from "react";
import { TextField, BooleanField, NumberField } from "react-admin";
import { MyList } from "../../_myBase/components/myList";
import useFieldPreferences from "../../hooks/useFieldPreferences";

const allFields = [
  {
    name: "id",
    component: NumberField,
    props: { label: "ID", sortable: false },
  },
  { name: "name", component: TextField, props: { label: "Name" } },
  { name: "isDefault", component: BooleanField, props: { label: "Default" } },
];

export default function DiscountPlanList(props) {
  const { visibleFields, loading, updatePreference } = useFieldPreferences(
    "discount-plans",
    allFields.map((f) => f.name)
  );

  if (loading) return <div>Loading...</div>;

  const filteredFields = allFields.filter((f) =>
    visibleFields.includes(f.name)
  );

  return (
    <MyList
      resource="discount-plans"
      {...props}
      fields={allFields.map((f) => f.name)}
      onPreferencesUpdate={updatePreference}
    >
      {filteredFields.map(
        ({ name, component: Component, props: fieldProps }) => (
          <Component key={name} source={name} {...fieldProps} />
        )
      )}
    </MyList>
  );
}
